import React from 'react';
import { IStatisticsPair, IParticipantsPair } from 'twain-sport-fe-mono/interfaces';

export const useParticipantsStatisticsPair = (participants: IParticipantsPair) =>
    React.useMemo<IStatisticsPair>(
        () => ({
            left: participants.left?.statistics || [],
            right: participants.right?.statistics || [],
        }),
        [participants],
    );
